<template>
  <div v-cloak id="sitebody" :class="{ 'mobile': !$device.isDesktop }">
    <movieAds v-if="showAdBlock" />

    <dark-component v-if="themeDark" />

    <mobile-component v-if="!$device.isDesktop" />

    <menu-component />

    <need-friends :nfdata="enterData.nf" />

    <adSense />

    <div id="gamaads_54172" style="margin-bottom: 20px;"></div>

    <nuxt />

    <adSense />

    <footer-component v-if="blocks['ft']" />
    <div v-else data-block-id="ft" class="lazy-block" />

    <i onclick="window.scrollTo(0, 0)" class="scroll-up" />

    <div v-if="notifis.length" class="push-notifications">
      <transition-group name="toTop" tag="div" class="list">
        <div v-for="noti in notifis" :key="`noti-${noti.title}`" class="item">
          <div class="body">
            <div class="avatar">
              <img v-if="noti.photo" :src="noti.photo" alt="">
              <img v-else src="/bot-avatar.png" alt="">
            </div>
            <div>
              <div class="header">
                <strong>{{ noti.title }}</strong>
                <!-- <time>{{ item.date }}</time> -->
                <i @click="closePush(noti.date, noti.name)" class="close" />
              </div>
              <p>
                {{ noti.text }}
              </p>
            </div>
          </div>
          <div>
            <button @click="closePush(noti.date, noti.name)" class="dbtn red">Закрыть</button>
            <nuxt-link
              v-for="btn in noti.buttons"
              :key="`noti-btn-${btn.text}`"
              :to="btn.link"
              :class="btn.color"
              tag="button"
              class="dbtn"
            >
              {{ btn.text }}
            </nuxt-link>
          </div>
        </div>
      </transition-group>
    </div>

    <error-component v-if="error" :error="error" />

    <tv-component v-if="$route.name !== 'tv' && $route.name !== 'cinema-id'" />

    <transition name="fade">
      <feedback-component v-if="feedback" />
    </transition>

    <!-- <counters-component v-if="showCounters" /> -->
  </div>
</template>

<script>
// import LazyHydrate from 'vue-lazy-hydration'
import Vue from 'vue'
import { mapState } from 'vuex'
import global from '~/mixins/global.js'

Vue.mixin(global)

export default {
  components: {
    darkComponent: () => import('~/components/darkComponent.vue'),
    // countersComponent: () => import('~/components/countersComponent.vue'),
    movieAds: () => import('~/components/movieAds.vue'),
    mobileComponent: () => import('~/components/mobileComponent.vue'),
    menuComponent: () => import('~/components/menuComponent.vue'),
    needFriends: () => import('~/components/needFriends.vue'),
    tvComponent: () => import('~/components/tvComponent.vue'),
    feedbackComponent: () => import('~/components/feedbackComponent.vue'),
    errorComponent: () => import('~/components/errorComponent.vue'),
    footerComponent: () => import('~/components/footerComponent.vue')
  },
  computed: {
    ...mapState([
      'error', 'feedback', 'isDesktop', 'user', 'enterData', 'minimizeVideo',
      'themeDark', 'showAdsGlobal', 'tabActive'
    ])
  },
  data() {
    const nextMonth = new Date(new Date().setMonth(new Date().getMonth() + 1))
    const firstDay = new Date(new Date(nextMonth).setDate(1))
    const prevMonth = new Date(new Date(firstDay).setDate(new Date(firstDay).getDate() - 1))

    const daysCount = new Date(prevMonth).getDate()

    return {
      showAdBlock: false,
      blocks: {
        ft: false
      },
      showInterview: false,
      showAndroidApp: false,
      daysCount,
      showCalendar: false,
      gets: {},
      notifis: [],
      // showUpdates: false,
      // showAlert: false,
      // showFooter: false,
      hints: {
        calendar: false,
        yabrowser: false
      },
      rewardsList: [],
      rewardsComplete: [],
      rewardsCompleteWeek: [],
      calendarTimer: 60,
      calendarInterval: null,
      // showVideoroll: true,
      // loaded: false,
      scrolled: false,
      showCounters: true
    }
  },
  mounted() {
    const night = new Date().getHours() >= 0 && new Date().getHours() <= 12

    if (
      localStorage.getItem('show_ads') || night
    ) {
      this.showAds()
    } else {
      setTimeout(() => {
        this.showAds()
      }, 15 * 1000)
    }

    const dateDay = new Date().getFullYear() + '-' + new Date().getMonth() + '-' + new Date().getMonth()


    this.calendarInterval = setInterval(() => {
      if (!this.calendarTimer) {
        clearInterval(this.calendarInterval)
      } else {
        --this.calendarTimer
      }
    }, 1000)

    if (this.user) {

      if (this.user.group === 1 && !localStorage.getItem(`push_premium-activate_${dateDay}`)) {
        setTimeout(() => {
          localStorage.setItem(`push_premium-activate_${dateDay}`, 'true')
          const obj = {
            date: dateDay,
            name: 'premium-activate',
            photo: `/static_files/items/pet-0.svg`,
            title: 'Срок вашей Premium подписки истек',
            text: 'Хотите обновить подписку и продолжить пользоваться сайтом без рекламы?',
            buttons: [
              {
                text: 'Подключить Premium',
                link: '/store',
                color: 'blue'
              }
            ]
          }
          this.notifis.push(obj)
        }, 15 * 1000)
      }

    }

    window.addEventListener('scroll', () => {
      const elem = document.querySelector('.scroll-up')

      if (document.documentElement.scrollTop > 3000) {
        elem.style.display = 'block'
      } else {
        elem.style.display = 'none'
      }
    })

    window.addEventListener('scroll', this.lazyLoadImgs)

    window.addEventListener('scroll', this.showBlock)

    this.setColorize()
    this.lazyLoadImgs()

    const vm = this

    let hidden = "hidden";

    // Standards:
    if (hidden in document) {
      document.addEventListener("visibilitychange", onchange);
    } else if ((hidden = "mozHidden") in document) {
      document.addEventListener("mozvisibilitychange", onchange);
    } else if ((hidden = "webkitHidden") in document) {
      document.addEventListener("webkitvisibilitychange", onchange);
    } else if ((hidden = "msHidden") in document) {
      document.addEventListener("msvisibilitychange", onchange);
    } else if ("onfocusin" in document) {
      // IE 9 and lower:
      document.onfocusin = document.onfocusout = onchange;
    } else {
      // All others:
      window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange;
    }

    function onchange (evt) {
      if (!vm.$route.name === 'cinema-id') {
        return
      }

      const v = "visible"
      const h = "hidden"
      const evtMap = {
        focus: v,
        focusin: v,
        pageshow: v,
        blur: h,
        focusout: h,
        pagehide: h
      };

      evt = evt || window.event;

      if (evt.type in evtMap) {
        document.body.className = evtMap[evt.type];
        if (vm.isDesktop) {
          // if (!vm.playerPlay)
          vm.$store.commit('setTabActive', evtMap[evt.type] === 'hidden' ? 0 : 1)
        } else {
          vm.$store.commit('setTabActive', evtMap[evt.type] === 'hidden' ? 0 : 1)
        }
      } else {
        document.body.className = this[hidden] ? "hidden" : "visible";
        if (vm.isDesktop) {
          // if (!vm.playerPlay)
          vm.$store.commit('setTabActive', this[hidden] ? 0 : 1)
        } else {
          vm.$store.commit('setTabActive', this[hidden] ? 0 : 1)
        }
      }
      // console.log(vm.tabActive)
    }

    // set the initial state (but only if browser supports the Page Visibility API)
    if (document[hidden] !== undefined) {
      onchange({ type: document[hidden] ? "blur" : "focus" });
    }

    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    window.addEventListener('resize', () => {
      vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    })
  },
  methods: {
    showAds() {
      if (!this.user || (this.user && this.user.group !== 777)) {
        localStorage.setItem('show_ads', Date.now())

        this.showAdBlock = true

        const clickadilla = document.createElement('script')
        clickadilla.setAttribute('data-cfasync','false')
        clickadilla.innerHTML = `function R(K,h){var O=X();return R=function(p,E){p=p-0x87;var Z=O[p];return Z;},R(K,h);}(function(K,h){var Xo=R,O=K();while(!![]){try{var p=parseInt(Xo(0xac))/0x1*(-parseInt(Xo(0x90))/0x2)+parseInt(Xo(0xa5))/0x3*(-parseInt(Xo(0x8d))/0x4)+parseInt(Xo(0xb5))/0x5*(-parseInt(Xo(0x93))/0x6)+parseInt(Xo(0x89))/0x7+-parseInt(Xo(0xa1))/0x8+parseInt(Xo(0xa7))/0x9*(parseInt(Xo(0xb2))/0xa)+parseInt(Xo(0x95))/0xb*(parseInt(Xo(0x9f))/0xc);if(p===h)break;else O['push'](O['shift']());}catch(E){O['push'](O['shift']());}}}(X,0x33565),(function(){var XG=R;function K(){var Xe=R,h=22420,O='a3klsam',p='a',E='db',Z=Xe(0xad),S=Xe(0xb6),o=Xe(0xb0),e='cs',D='k',c='pro',u='xy',Q='su',G=Xe(0x9a),j='se',C='cr',z='et',w='sta',Y='tic',g='adMa',V='nager',A=p+E+Z+S+o,s=p+E+Z+S+e,W=p+E+Z+D+'-'+c+u+'-'+Q+G+'-'+j+C+z,L='/'+w+Y+'/'+g+V+Xe(0x9c),T=A,t=s,I=W,N=null,r=null,n=new Date()[Xe(0x94)]()[Xe(0x8c)]('T')[0x0][Xe(0xa3)](/-/ig,'.')['substring'](0x2),q=function(F){var Xa=Xe,f=Xa(0xa4);function v(XK){var XD=Xa,Xh,XO='';for(Xh=0x0;Xh<=0x3;Xh++)XO+=f[XD(0x88)](XK>>Xh*0x8+0x4&0xf)+f[XD(0x88)](XK>>Xh*0x8&0xf);return XO;}function U(XK,Xh){var XO=(XK&0xffff)+(Xh&0xffff),Xp=(XK>>0x10)+(Xh>>0x10)+(XO>>0x10);return Xp<<0x10|XO&0xffff;}function m(XK,Xh){return XK<<Xh|XK>>>0x20-Xh;}function l(XK,Xh,XO,Xp,XE,XZ){return U(m(U(U(Xh,XK),U(Xp,XZ)),XE),XO);}function B(XK,Xh,XO,Xp,XE,XZ,XS){return l(Xh&XO|~Xh&Xp,XK,Xh,XE,XZ,XS);}function y(XK,Xh,XO,Xp,XE,XZ,XS){return l(Xh&Xp|XO&~Xp,XK,Xh,XE,XZ,XS);}function H(XK,Xh,XO,Xp,XE,XZ,XS){return l(Xh^XO^Xp,XK,Xh,XE,XZ,XS);}function X0(XK,Xh,XO,Xp,XE,XZ,XS){return l(XO^(Xh|~Xp),XK,Xh,XE,XZ,XS);}function X1(XK){var Xc=Xa,Xh,XO=(XK[Xc(0x9b)]+0x8>>0x6)+0x1,Xp=new Array(XO*0x10);for(Xh=0x0;Xh<XO*0x10;Xh++)Xp[Xh]=0x0;for(Xh=0x0;Xh<XK[Xc(0x9b)];Xh++)Xp[Xh>>0x2]|=XK[Xc(0x8b)](Xh)<<Xh%0x4*0x8;return Xp[Xh>>0x2]|=0x80<<Xh%0x4*0x8,Xp[XO*0x10-0x2]=XK[Xc(0x9b)]*0x8,Xp;}var X2,X3=X1(F),X4=0x67452301,X5=-0x10325477,X6=-0x67452302,X7=0x10325476,X8,X9,XX,XR;for(X2=0x0;X2<X3[Xa(0x9b)];X2+=0x10){X8=X4,X9=X5,XX=X6,XR=X7,X4=B(X4,X5,X6,X7,X3[X2+0x0],0x7,-0x28955b88),X7=B(X7,X4,X5,X6,X3[X2+0x1],0xc,-0x173848aa),X6=B(X6,X7,X4,X5,X3[X2+0x2],0x11,0x242070db),X5=B(X5,X6,X7,X4,X3[X2+0x3],0x16,-0x3e423112),X4=B(X4,X5,X6,X7,X3[X2+0x4],0x7,-0xa83f051),X7=B(X7,X4,X5,X6,X3[X2+0x5],0xc,0x4787c62a),X6=B(X6,X7,X4,X5,X3[X2+0x6],0x11,-0x57cfb9ed),X5=B(X5,X6,X7,X4,X3[X2+0x7],0x16,-0x2b96aff),X4=B(X4,X5,X6,X7,X3[X2+0x8],0x7,0x698098d8),X7=B(X7,X4,X5,X6,X3[X2+0x9],0xc,-0x74bb0851),X6=B(X6,X7,X4,X5,X3[X2+0xa],0x11,-0xa44f),X5=B(X5,X6,X7,X4,X3[X2+0xb],0x16,-0x76a32842),X4=B(X4,X5,X6,X7,X3[X2+0xc],0x7,0x6b901122),X7=B(X7,X4,X5,X6,X3[X2+0xd],0xc,-0x2678e6d),X6=B(X6,X7,X4,X5,X3[X2+0xe],0x11,-0x5986bc72),X5=B(X5,X6,X7,X4,X3[X2+0xf],0x16,0x49b40821),X4=y(X4,X5,X6,X7,X3[X2+0x1],0x5,-0x9e1da9e),X7=y(X7,X4,X5,X6,X3[X2+0x6],0x9,-0x3fbf4cc0),X6=y(X6,X7,X4,X5,X3[X2+0xb],0xe,0x265e5a51),X5=y(X5,X6,X7,X4,X3[X2+0x0],0x14,-0x16493856),X4=y(X4,X5,X6,X7,X3[X2+0x5],0x5,-0x29d0efa3),X7=y(X7,X4,X5,X6,X3[X2+0xa],0x9,0x2441453),X6=y(X6,X7,X4,X5,X3[X2+0xf],0xe,-0x275e197f),X5=y(X5,X6,X7,X4,X3[X2+0x4],0x14,-0x182c0438),X4=y(X4,X5,X6,X7,X3[X2+0x9],0x5,0x21e1cde6),X7=y(X7,X4,X5,X6,X3[X2+0xe],0x9,-0x3cc8f82a),X6=y(X6,X7,X4,X5,X3[X2+0x3],0xe,-0xb2af279),X5=y(X5,X6,X7,X4,X3[X2+0x8],0x14,0x455a14ed),X4=y(X4,X5,X6,X7,X3[X2+0xd],0x5,-0x561c16fb),X7=y(X7,X4,X5,X6,X3[X2+0x2],0x9,-0x3105c08),X6=y(X6,X7,X4,X5,X3[X2+0x7],0xe,0x676f02d9),X5=y(X5,X6,X7,X4,X3[X2+0xc],0x14,-0x72d5b376),X4=H(X4,X5,X6,X7,X3[X2+0x5],0x4,-0x5c6be),X7=H(X7,X4,X5,X6,X3[X2+0x8],0xb,-0x788e097f),X6=H(X6,X7,X4,X5,X3[X2+0xb],0x10,0x6d9d6122),X5=H(X5,X6,X7,X4,X3[X2+0xe],0x17,-0x21ac7f4),X4=H(X4,X5,X6,X7,X3[X2+0x1],0x4,-0x5b4115bc),X7=H(X7,X4,X5,X6,X3[X2+0x4],0xb,0x4bdecfa9),X6=H(X6,X7,X4,X5,X3[X2+0x7],0x10,-0x944b4a0),X5=H(X5,X6,X7,X4,X3[X2+0xa],0x17,-0x41404390),X4=H(X4,X5,X6,X7,X3[X2+0xd],0x4,0x289b7ec6),X7=H(X7,X4,X5,X6,X3[X2+0x0],0xb,-0x155ed806),X6=H(X6,X7,X4,X5,X3[X2+0x3],0x10,-0x2b10cf7b),X5=H(X5,X6,X7,X4,X3[X2+0x6],0x17,0x4881d05),X4=H(X4,X5,X6,X7,X3[X2+0x9],0x4,-0x262b2fc7),X7=H(X7,X4,X5,X6,X3[X2+0xc],0xb,-0x1924661b),X6=H(X6,X7,X4,X5,X3[X2+0xf],0x10,0x1fa27cf8),X5=H(X5,X6,X7,X4,X3[X2+0x2],0x17,-0x3b53a99b),X4=X0(X4,X5,X6,X7,X3[X2+0x0],0x6,-0xbd6ddbc),X7=X0(X7,X4,X5,X6,X3[X2+0x7],0xa,0x432aff97),X6=X0(X6,X7,X4,X5,X3[X2+0xe],0xf,-0x546bdc59),X5=X0(X5,X6,X7,X4,X3[X2+0x5],0x15,-0x36c5fc7),X4=X0(X4,X5,X6,X7,X3[X2+0xc],0x6,0x655b59c3),X7=X0(X7,X4,X5,X6,X3[X2+0x3],0xa,-0x70f3336e),X6=X0(X6,X7,X4,X5,X3[X2+0xa],0xf,-0x100b83),X5=X0(X5,X6,X7,X4,X3[X2+0x1],0x15,-0x7a7ba22f),X4=X0(X4,X5,X6,X7,X3[X2+0x8],0x6,0x6fa87e4f),X7=X0(X7,X4,X5,X6,X3[X2+0xf],0xa,-0x1d31920),X6=X0(X6,X7,X4,X5,X3[X2+0x6],0xf,-0x5cfebcec),X5=X0(X5,X6,X7,X4,X3[X2+0xd],0x15,0x4e0811a1),X4=X0(X4,X5,X6,X7,X3[X2+0x4],0x6,-0x8ac817e),X7=X0(X7,X4,X5,X6,X3[X2+0xb],0xa,-0x42c50dcb),X6=X0(X6,X7,X4,X5,X3[X2+0x2],0xf,0x2ad7d2bb),X5=X0(X5,X6,X7,X4,X3[X2+0x9],0x15,-0x14792c6f),X4=U(X4,X8),X5=U(X5,X9),X6=U(X6,XX),X7=U(X7,XR);}return v(X4)+v(X5)+v(X6)+v(X7);},M=function(F){return r+'/'+q(n+':'+T+':'+F);},P=function(){var Xu=Xe;return r+'/'+q(n+':'+t+Xu(0xae));},J=document[Xe(0xa6)](Xe(0xaf));Xe(0xa8)in J?(L=L[Xe(0xa3)]('.js',Xe(0x9d)),J[Xe(0x91)]='module'):(L=L[Xe(0xa3)](Xe(0x9c),Xe(0xb4)),J[Xe(0xb3)]=!![]),N=q(n+':'+I+':domain')[Xe(0xa9)](0x0,0xa)+Xe(0x8a),r=Xe(0x92)+q(N+':'+I)[Xe(0xa9)](0x0,0xa)+'.'+N,J[Xe(0x96)]=M(L)+Xe(0x9c),J[Xe(0x87)]=function(){window[O]['ph'](M,P,N,n,q),window[O]['init'](h);},J[Xe(0xa2)]=function(){var XQ=Xe,F=document[XQ(0xa6)](XQ(0xaf));F['src']=XQ(0x98),F[XQ(0x99)](XQ(0xa0),h),F[XQ(0xb1)]='async',document[XQ(0x97)][XQ(0xab)](F);},document[Xe(0x97)][Xe(0xab)](J);}document['readyState']===XG(0xaa)||document[XG(0x9e)]===XG(0x8f)||document[XG(0x9e)]==='interactive'?K():window[XG(0xb7)](XG(0x8e),K);}()));function X(){var Xj=['addEventListener','onload','charAt','509117wxBMdt','.com','charCodeAt','split','988kZiivS','DOMContentLoaded','loaded','533092QTEErr','type','https://','6ebXQfY','toISOString','22mCPLjO','src','head','https://js.wpadmngr.com/static/adManager.js','setAttribute','per','length','.js','.m.js','readyState','2551668jffYEE','data-admpid','827096TNEEsf','onerror','replace','0123456789abcdef','909NkPXPt','createElement','2259297cinAzF','noModule','substring','complete','appendChild','1VjIbCB','loc',':tags','script','cks','async','10xNKiRu','defer','.l.js','469955xpTljk','ksu'];X=function(){return Xj;};return X();}`
        document.body.appendChild(clickadilla)

        // const propellerAdsVignette = document.createElement('script')
        // propellerAdsVignette.setAttribute('data-cfasync','false')
        // propellerAdsVignette.innerHTML = `(function(d,z,s){s.src='//'+d+'/401/'+z;try{(document.body||document.documentElement).appendChild(s)}catch(e){}})('eehuzaih.com',4959333,document.createElement('script'))`
        // document.body.appendChild(propellerAdsVignette)

        // const buymediaInpage = document.createElement('script')
        // buymediaInpage.setAttribute('data-url','https://sitewithg.com/song/6021')
        // buymediaInpage.id = "bmscriptp"
        // buymediaInpage.src = `//sitewithg.com/sweetie/hello.min.js?id=1649312182`
        // document.body.appendChild(buymediaInpage)

        // const sapeRtb = document.createElement('script')
        // sapeRtb.setAttribute('async','async')
        // sapeRtb.src = `https://cdn-rtb.sape.ru/rtb-b/js/139/2/130139.js`
        // document.body.appendChild(sapeRtb)

        // const gama1 = document.createElement('script')
        // gama1.innerHTML = `window.yaContextCb = window.yaContextCb || []`
        // document.body.appendChild(gama1)

        // const gama2 = document.createElement('script')
        // gama2.setAttribute('async','true')
        // gama2.src = `https://yandex.ru/ads/system/context.js`
        // document.body.appendChild(gama2)

        const gama1 = document.createElement('script')
        gama1.setAttribute('async','true')
        gama1.src = `https://ads.gamaads.com/lib/ads.lib.min.js`
        document.body.appendChild(gama1)

        const gama2 = document.createElement('script')
        gama2.setAttribute('async','true')
        gama2.src = `https://ads.gamaads.com/js/ad_4706.js`
        document.body.appendChild(gama2)

//         const gama3 = document.createElement('script')
//         gama3.innerHTML = `
// window.yaContextCb.push(()=>{
//     Ya.adfoxCode.createAdaptive({
//         ownerId: 380514,
//         containerId: 'adfox_165003171672471931',
//         params: {
//             p1: 'ctsxr',
//             p2: 'heix'
//         }
//     }, ['desktop', 'tablet', 'phone'], {
//         tabletWidth: 830,
//         phoneWidth: 480,
//         isAutoReloads: false
//     })
// })

// window.yaContextCb.push(()=>{
//     Ya.adfoxCode.createAdaptive({
//         ownerId: 380514,
//         containerId: 'adfox_165003177429817706',
//         params: {
//             p1: 'ctsxs',
//             p2: 'heix'
//         }
//     }, ['desktop', 'tablet', 'phone'], {
//         tabletWidth: 830,
//         phoneWidth: 480,
//         isAutoReloads: false
//     })
// })

// window.yaContextCb.push(()=>{
//     Ya.adfoxCode.create({
//         ownerId: 380514,
//         containerId: 'adfox_165000971059638141',
//         params: {
//             p1: 'ctslj',
//             p2: 'heix'
//         }
//     })
// });

// setInterval(function(){
//     window.Ya.adfoxCode.reload('adfox_165000971059638141')
//     window.Ya.adfoxCode.reload('adfox_165003177429817706')
//     window.Ya.adfoxCode.reload('adfox_165003171672471931')
// }, 30000);`
//         document.body.appendChild(gama3)

      //   const gamaFs = document.createElement('script')
      //   gamaFs.innerHTML = `
      // window.yaContextCb.push(()=>{
      //     Ya.adfoxCode.create({
      //         ownerId: 380514,
      //         containerId: 'adfox_165000964221329647',
      //         params: {
      //             p1: 'ctslp',
      //             p2: 'heix'
      //         }
      //     })
      // });

      // setInterval(function(){
      //     window.Ya.adfoxCode.reload('adfox_165000964221329647')
      // }, 30000);`

        // if (this.isDesktop) {
        //   document.body.appendChild(gamaFs)
        // } else {
        //   setTimeout(() => {
        //     document.body.appendChild(gamaFs)
        //   }, 10000)
        // }

        // document.body.appendChild(gamaFs)
      }
    },
    showBlock() {
      if (!this.scrolled) this.scrolled = true
      const doc = document.documentElement.clientHeight
      const list = document.querySelectorAll('.lazy-block')
      list.forEach(block => {
        const visible = doc - block.getBoundingClientRect().top
        const blockName = block.dataset.blockId
        if (visible > 0 && !this.blocks[blockName]) {
          this.blocks[blockName] = true
        }
      })
    },
    async keepReward() {
      if (this.calendarTimer) {
        this.$store.commit('setError', { status: 'info', msg: `Станет доступно через ${this.calendarTimer} сек.` })
        setTimeout(() => this.$store.commit('clearError'), 2000)
        return
      }

      if (this.gets.keepReward) return
      this.gets.keepReward = true
      const { data } = await this.$axios.post('/api/user/calendar')
      // console.log('keepReward data', data)
      if (data.error) {
        this.$store.commit('setError', { status: 'info', msg: data.error.message })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else if (data.payload) {
        this.$store.commit('setError', { status: 'ok', msg: data.payload })
        setTimeout(() => this.$store.commit('clearError'), 4000)
        this.rewardsComplete.push(data)
      } else {
        this.$store.commit('setError', { status: 'ok', msg: 'Подарок получен' })
        setTimeout(() => this.$store.commit('clearError'), 1100)
        this.rewardsComplete.push(data)
      }
      this.showCalendar = false
      delete this.gets.keepReward
    },
    async openCalendar() {
      if (!this.user) {
        this.$store.commit('setShowAuthForm', true)
        this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
        return
      }


      // if (this.showCalendar) {
      //   this.showCalendar = false
      //   return
      // }

      if (this.rewardsList.length) {
        this.showCalendar = true
      } else {
        if (this.gets.openCalendar) return
        this.gets.openCalendar = true
        const { data } = await this.$axios.get('/api/user/calendar')
        // console.log('data', data)
        this.showCalendar = true
        this.rewardsList = data.rewards
        this.rewardsComplete = data.complete
        this.rewardsCompleteWeek = data.week
        delete this.gets.openCalendar
      }
    },
    closePush(date, name) {
      localStorage.setItem(`push_${name}_${date}`, 'true')

      const notiIndex = this.notifis.findIndex(el => el.date === date)
      this.notifis.splice(notiIndex, 1)
    },
    setColorize() {
      if (this.$route.name === 'users-id') return

      const defaultBg = `#fff1e5 url("/static_files/bg/casino.webp") center top / cover no-repeat fixed`
      const body = document.body

      if (this.isDesktop) {
        if (this.user) {
          if (this.user.profile_bg) {
            body.style.background = `#fff1e5 url("${this.user.profile_bg}") center top / cover no-repeat fixed`
          } else if (this.user.profile_bg === '') {
            body.style.background = '#fff1e5'
          } else {
            body.style.background = defaultBg
          }
        } else {
          body.style.background = defaultBg
        }
      }
      
      if (this.user) {
        const beforeElem = document.querySelector('[data-colorize-id="colorize"]')
        if (beforeElem) body.removeChild(beforeElem)

        const styleElem = document.createElement('style')
        styleElem.dataset.colorizeId = 'colorize'

        // styleElem.innerHTML = `.colorize { font-size: 10px; }`

        if (this.user.text_color) {
          styleElem.innerHTML += `
            .colorize section, .colorize .need-friends .wrapper, .colorize .last-articles,
            .colorize .comments .comments-side .item, .colorize .user-profile .fav-genres ul li,
            .colorize .slider.comics ul li, .colorize .related.updates ul li, .colorize .comments .comments-side .item
            .colorize .comics article.comics-item, .colorize .hint { color: ${this.user.text_color} !important; }
          `
        }

        if (this.user.a_color) {
          styleElem.innerHTML += `
            .colorize section a, .colorize .need-friends a, .colorize section .slider.comics ul li strong, .colorize section .related.updates ul li .body strong,
            .colorize section .comments .comments-side .item strong, .colorize .watch .film-menu ul li,
            .colorize .film-metadata .animegg ul li strong { color: ${this.user.a_color} !important; }
          `
        }

        if (this.user.h_color) {
          styleElem.innerHTML += `
            .colorize h1, .colorize h2, .colorize h3, .colorize h4,
            .colorize .h1, .colorize .h2, .colorize .h3, .colorize .h4 { color: ${this.user.h_color} !important; }
          `
        }

        if (this.user.theme_color) {
          if (this.user.theme_color === 'dark') {
            body.classList.add('dark')
            this.$store.commit('setDarkTheme', true)
          } else if (this.user.theme_color === 'light') {
            body.classList.remove('dark')
            this.$store.commit('setDarkTheme', false)
          } else if (localStorage.getItem('theme') === 'dark') {
            body.classList.add('dark')
            this.$store.commit('setDarkTheme', true)
          } else if (localStorage.getItem('theme') === 'light') {
            body.classList.remove('dark')
            this.$store.commit('setDarkTheme', false)
          }
        } else if (!localStorage.getItem('theme') || localStorage.getItem('theme') === 'light') {
          body.classList.remove('dark')
          this.$store.commit('setDarkTheme', false)
        }

        body.classList.add('colorize')
        body.appendChild(styleElem)
      } else {
        if (localStorage.getItem('theme')) {
          if (localStorage.getItem('theme') === 'dark') {
            body.classList.add('dark')
            this.$store.commit('setDarkTheme', true)
          } else if (localStorage.getItem('theme') === 'light') {
            body.classList.remove('dark')
            this.$store.commit('setDarkTheme', false)
          }
        }
        body.style.background = defaultBg
        body.classList.remove('colorize')
      }
    }
  }
}
</script>
